import FoodImage1 from '../images/foodImages/other/Food_img1.jpg';

const OtherItems = [
  { id: 1, name: '敘月風味炸雞', price: 280, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 2, name: '蒜香乾烙海鮮', price: 380, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 3, name: '三杯米腸雞', price: 280, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 4, name: '松阪豬炒泡麵', price: 320, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 5, name: '酒香甩子牛', price: 390, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 6, name: '香煎牛小排', price: 380, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 7, name: '三杯雞炒泡麵', price: 290, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 8, name: '火爆浪子雞', price: 290, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
];

export default OtherItems;
